import type { MouseEvent } from "react";
import classNames from "classnames";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { TaskBlockedIcon } from "@icons/taskStatuses";
import styles from "./TaskBlockedBadge.module.scss";

interface TaskBlockedBadgeProps {
    label: string;
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
    /** The clickable badge's tab stop, e.g. a grid cell control's roving index. */
    tabIndex?: number;
}

export const TaskBlockedBadge = ({
    label,
    onClick,
    tabIndex,
}: TaskBlockedBadgeProps) => {
    const icon = <TaskBlockedIcon className={styles.icon} />;

    return (
        <Tooltip content={label}>
            {onClick ? (
                <button
                    type="button"
                    className={classNames(styles.badge, styles.clickable)}
                    aria-label={label}
                    tabIndex={tabIndex}
                    onClick={onClick}
                >
                    {icon}
                </button>
            ) : (
                <span role="img" className={styles.badge} aria-label={label}>
                    {icon}
                </span>
            )}
        </Tooltip>
    );
};
